<div class="gw-space-y-6">
  <h3 class="gw-text-lg gw-font-semibold gw-text-text-primary">
    {{ 'features.domains.settings.style.title' | translate }}
  </h3>

  <div
    class="gw-grid gw-grid-cols-1 md:gw-grid-cols-2 lg:gw-grid-cols-3 gw-gap-4"
  >
    <!-- Primary Color -->
    <div class="gw-space-y-2" [formGroup]="internalFormGroup">
      <label class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block">
        {{ 'features.domains.settings.style.primaryColor' | translate }}
      </label>
      <div class="gw-flex gw-gap-2 gw-items-center">
        <input
          type="color"
          [value]="internalFormGroup.get('primaryColor')?.value || '#0066CC'"
          (input)="onColorChange('primaryColor', $event)"
          class="gw-w-12 gw-h-10 gw-rounded gw-border gw-border-border-normal gw-cursor-pointer"
        />
        <input
          type="text"
          formControlName="primaryColor"
          id="primary-color"
          placeholder="#0066CC"
          class="gw-input-base gw-flex-1 gw-h-10 gw-px-3 gw-rounded gw-border gw-border-border-normal gw-text-sm focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-border-focus"
        />
      </div>
    </div>

    <!-- Secondary Color -->
    <div class="gw-space-y-2" [formGroup]="internalFormGroup">
      <label class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block">
        {{ 'features.domains.settings.style.secondaryColor' | translate }}
      </label>
      <div class="gw-flex gw-gap-2 gw-items-center">
        <input
          type="color"
          [value]="internalFormGroup.get('secondaryColor')?.value || '#003366'"
          (input)="onColorChange('secondaryColor', $event)"
          class="gw-w-12 gw-h-10 gw-rounded gw-border gw-border-border-normal gw-cursor-pointer"
        />
        <input
          type="text"
          formControlName="secondaryColor"
          id="secondary-color"
          placeholder="#003366"
          class="gw-input-base gw-flex-1 gw-h-10 gw-px-3 gw-rounded gw-border gw-border-border-normal gw-text-sm focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-border-focus"
        />
      </div>
    </div>

    <!-- Accent Color -->
    <div class="gw-space-y-2" [formGroup]="internalFormGroup">
      <label class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block">
        {{ 'features.domains.settings.style.accentColor' | translate }}
      </label>
      <div class="gw-flex gw-gap-2 gw-items-center">
        <input
          type="color"
          [value]="internalFormGroup.get('accentColor')?.value || '#0099FF'"
          (input)="onColorChange('accentColor', $event)"
          class="gw-w-12 gw-h-10 gw-rounded gw-border gw-border-border-normal gw-cursor-pointer"
        />
        <input
          type="text"
          formControlName="accentColor"
          id="accent-color"
          placeholder="#0099FF"
          class="gw-input-base gw-flex-1 gw-h-10 gw-px-3 gw-rounded gw-border gw-border-border-normal gw-text-sm focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-border-focus"
        />
      </div>
    </div>
  </div>

  <div class="gw-grid gw-grid-cols-1 md:gw-grid-cols-2 gw-gap-4">
    <div>
      <gatewee-asset-upload
        [control]="logoControl"
        assetType="brandingLogo"
        [domainId]="domainId"
        [label]="'features.domains.settings.style.logo' | translate"
      ></gatewee-asset-upload>
    </div>

    <div>
      <gatewee-asset-upload
        [control]="logoBlackControl"
        assetType="brandingLogo"
        [domainId]="domainId"
        [label]="'features.domains.settings.style.logoBlack' | translate"
      ></gatewee-asset-upload>
    </div>

    <div>
      <gatewee-asset-upload
        [control]="logoWhiteControl"
        assetType="brandingLogo"
        [domainId]="domainId"
        [label]="'features.domains.settings.style.logoWhite' | translate"
      ></gatewee-asset-upload>
    </div>

    <div>
      <gatewee-asset-upload
        [control]="logoSymbolControl"
        assetType="brandingIcon"
        [domainId]="domainId"
        [aspectRatio]="1"
        [resizeToWidth]="512"
        [resizeToHeight]="512"
        [label]="'features.domains.settings.style.logoSymbol' | translate"
      ></gatewee-asset-upload>
    </div>

    <div>
      <gatewee-asset-upload
        [control]="faviconControl"
        assetType="brandingIcon"
        [domainId]="domainId"
        [aspectRatio]="1"
        [resizeToWidth]="512"
        [resizeToHeight]="512"
        [label]="'features.domains.settings.style.favicon' | translate"
      ></gatewee-asset-upload>
    </div>

    <!-- Theme -->
    <div [formGroup]="internalFormGroup">
      <gatewee-select-v3
        [label]="'features.domains.settings.style.theme.label' | translate"
        id="theme"
        [items]="themeOptions"
        [placeholder]="
          'features.domains.settings.style.theme.placeholder' | translate
        "
        formControlName="theme"
      ></gatewee-select-v3>
    </div>
  </div>
</div>
